import { useState, cloneElement } from 'react';

// The prototype leaned on a non-standard `style-hover` attribute. React has no built-in
// equivalent for inline styles, so this helper merges `hoverStyle` over `style` while
// the pointer is over the element.
//
//   <Hoverable as="button" style={base} hoverStyle={{ background: '#7fb0ff' }} onClick={fn}>
//     Click
//   </Hoverable>
//
// It also composes cleanly with magnetic handlers (onMouseMove/onMouseLeave) passed in
// via `...rest`, chaining the leave handler so both fire.
export function Hoverable({
  as: Tag = 'div',
  style,
  hoverStyle,
  children,
  onMouseEnter,
  onMouseLeave,
  onMouseMove,
  ...rest
}) {
  const [hover, setHover] = useState(false);

  return (
    <Tag
      style={hover ? { ...style, ...hoverStyle } : style}
      onMouseEnter={(e) => {
        setHover(true);
        onMouseEnter && onMouseEnter(e);
      }}
      onMouseLeave={(e) => {
        setHover(false);
        onMouseLeave && onMouseLeave(e);
      }}
      onMouseMove={onMouseMove}
      {...rest}
    >
      {children}
    </Tag>
  );
}

// Variant that decorates an existing element (used where we already build a node and
// just want hover swapping without changing the tag).
export function withHover(element, baseStyle, hoverStyle) {
  const Wrapped = () => {
    const [hover, setHover] = useState(false);
    return cloneElement(element, {
      style: hover ? { ...baseStyle, ...hoverStyle } : baseStyle,
      onMouseEnter: () => setHover(true),
      onMouseLeave: () => setHover(false),
    });
  };
  return <Wrapped />;
}
